import { Spin, BackTop } from 'antd';
import React from 'react';
import { Route, Switch } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as authenticationActions from '../actions/authenticationActions';

import asyncComponent from '../AsyncComponent';

import ProductsPage from './registry/network/ProductsPage';
import QuotationPage from './emission/QuotationPage';
import RendicontazionePage from './reporting/RendicontazionePage';
import RendicontazioneXSocioSostenitorePage from './reporting/RendicontazioneXSocioSostenitorePage';
import TariffPage from './registry/tariff/edit/TariffPage';
import TariffGroupsPage from './registry/tariff/TariffGroupsPage';
import TariffsPage from './registry/tariff/TariffsPage';
import UsersPage from './registry/user/UsersPage';
import UserPage from './registry/user/edit/UserPage';
import UserBasicPage from './registry/user/basic/UserBasicPage';
import WarrantyPage from './registry/warranty/edit/WarrantyPage';
import WarrantiesPage from './registry/warranty/WarrantiesPage';

// *************************************************************
// Set the locale for all the moment Objects (moment is a static Object)
import moment from 'moment';
import 'moment/locale/it';
moment.locale('it');
// *************************************************************

// *************************************************************
// Just a sample to test Lazy Loading
// import AgentPage from './registry/agent/edit/AgentPage'
const AgentPage = asyncComponent(() => import('./registry/agent/edit/AgentPage').then(module => module.default));
const AgentsPage = asyncComponent(() => import('./registry/agent/AgentsPage').then(module => module.default));
const CertificazioneIncassiPage = asyncComponent(() => import('./reporting/CertificazioneIncassiPage').then(module => module.default));
const CompanyPage = asyncComponent(() => import('./registry/company/edit/CompanyPage').then(module => module.default));
const CompaniesPage = asyncComponent(() => import('./registry/company/CompaniesPage').then(module => module.default));
const ContractManagerPage = asyncComponent(() => import('./management/ContractManagerPage').then(module => module.default));
const ContractResumePage = asyncComponent(() => import('./management/ContractResumePage').then(module => module.default));
const CustomerPage = asyncComponent(() => import('./registry/customer/edit/CustomerPage').then(module => module.default));
const CustomersPage = asyncComponent(() => import('./registry/customer/CustomersPage').then(module => module.default));
const CreateMyQuotationPage = asyncComponent(() => import('./quotation/CreateMyQuotationPage').then(module => module.default));
const EmissionPage = asyncComponent(() => import('./emission/EmissionPage').then(module => module.default));
const EstrattoContoPage = asyncComponent(() => import('./reporting/EstrattoContoPage').then(module => module.default));
const EstrattoContoIncassiPage = asyncComponent(() => import('./reporting/EstrattoContoIncassiPage').then(module => module.default));
const EstrattoContoQuoteSociSostenitoriPage = asyncComponent(() => import('./reporting/EstrattoContoQuoteSociSostenitoriPage').then(module => module.default));
const EstrattoContoReferentePage = asyncComponent(() => import('./reporting/EstrattoContoReferentePage').then(module => module.default));
const EstrattoContoSociSostenitoriPage = asyncComponent(() => import('./reporting/EstrattoContoSociSostenitoriPage').then(module => module.default));
const EstrattoContoPianoFlexPage = asyncComponent(() => import('./reporting/EstrattoContoPianoFlexPage').then(module => module.default));
const EstrazioneAnagrafichePage = asyncComponent(() => import('./reporting/EstrazioneAnagrafichePage').then(module => module.default));
const Header = asyncComponent(() => import('./common/Header').then(module => module.default));
const HomePage = asyncComponent(() => import('./HomePage').then(module => module.default));
const LoginPage = asyncComponent(() => import('./authentication/LoginPage').then(module => module.default));
const LoginWithTokenPage = asyncComponent(() => import('./authentication/LoginWithTokenPage').then(module => module.default));
const LoginSsoPage = asyncComponent(() => import('./authentication/LoginSsoPage').then(module => module.default));
const LogoffPage = asyncComponent(() => import('./authentication/LogoffPage').then(module => module.default));
const NetworkPage = asyncComponent(() => import('./registry/network/edit/NetworkPage').then(module => module.default));
const NetworksPage = asyncComponent(() => import('./registry/network/NetworksPage').then(module => module.default));
const PasswordForgotten = asyncComponent(() => import('./authentication/PasswordForgotten').then(module => module.default));
const PasswordReset = asyncComponent(() => import('./authentication/PasswordReset').then(module => module.default));

// *************************************************************


class App extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      authenticationState: Object.assign({}, this.props.authenticationState),
      commonState: this.props.commonState
    };

    this.logOut = this.logOut.bind(this);
  }

  componentDidMount() {
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return Object.assign({}, prevState, { authenticationState: nextProps.authenticationState, commonState: nextProps.commonState });
  }

  logOut() {
    this.props.authentication.logout().then(() => {
      window.location.href = process.env.REACT_APP_FE + '#/login';
    }).catch(error => {
      window.location.href = process.env.REACT_APP_FE + '#/login';
    });
  }

  render() {
    var isLoggedIn = (this.state.authenticationState !== undefined && this.state.authenticationState.token !== undefined && this.state.authenticationState.token !== '');
    var blocking = this.state.commonState.blocking > 0;

    return (
      <Spin spinning={blocking} size="large">
        {isLoggedIn ? <Header authenticationState={this.state.authenticationState} logOut={this.logOut} /> : ''}
        <BackTop />
        <div className="container-fluid">
          <Switch>
            {/* Pages */}
     
            <Route path="/agent" exact component={AgentPage} />
            <Route path="/agent/:id" component={AgentPage} />
            <Route path="/agents" exact component={AgentsPage} />
            <Route path="/company" exact component={CompanyPage} />
            <Route path="/company/:id" component={CompanyPage} />
            <Route path="/companies" exact component={CompaniesPage} />
            <Route path="/contractResume/:id" component={ContractResumePage} />
            <Route path="/contracts" exact component={ContractManagerPage} />
            <Route path="/customer" exact component={CustomerPage} />
            <Route path="/customer/:id" exact component={CustomerPage} />
            <Route path="/customers" exact component={CustomersPage} />
            <Route path="/emission" exact component={EmissionPage} />
            <Route path="/estrattoConto" exact component={EstrattoContoPage} />
            <Route path="/estrattoContoSociSostenitori" exact component={EstrattoContoSociSostenitoriPage} />
            <Route path="/estrattoContoIncassi" exact component={EstrattoContoIncassiPage} />
            <Route path="/estrattoContoReferenti" exact component={EstrattoContoReferentePage} />
            <Route path="/estrattoContoQuoteSociSostenitori" exact component={EstrattoContoQuoteSociSostenitoriPage} />
            <Route path="/estrattoContoPianoFlex" exact component={EstrattoContoPianoFlexPage} />
            <Route path="/estrazioneAnagrafiche" exact component={EstrazioneAnagrafichePage} />
            <Route path="/certificazioneIncassi" exact component={CertificazioneIncassiPage} />
            <Route path="/network" exact component={NetworkPage} />
            <Route path="/network/:id" component={NetworkPage} />
            <Route path="/networks" exact component={NetworksPage} />
            <Route path="/productsTariffs" exact component={ProductsPage} />
            <Route path="/quotation" exact component={QuotationPage} />
            <Route path="/rendicontazione" exact component={RendicontazionePage} />
            <Route path="/RendicontazioneXSocioSostenitorePage" exact component={RendicontazioneXSocioSostenitorePage} />
            <Route path="/tariff" exact component={TariffPage} />
            <Route path="/tariff/:id" component={TariffPage} />
            <Route path="/tariffGroups" component={TariffGroupsPage} />
            <Route path="/tariffs" exact component={TariffsPage} />
            <Route path="/warranty" exact component={WarrantyPage} />
            <Route path="/warranty/:id" component={WarrantyPage} />
            <Route path="/warranties" exact component={WarrantiesPage} />
            <Route path="/users" exact component={UsersPage} />
            <Route path="/user" exact component={UserPage} />
            <Route path="/user/:id" exact component={UserPage} />
            <Route path="/userBasic/:id" exact component={UserBasicPage} />

            {/* Authentication*/}
            <Route path="/loginWithToken/:sanityToken" exact component={LoginWithTokenPage} />
            <Route path="/loginSso/:isakToken" component={LoginSsoPage} />
            <Route path="/login" exact component={LoginPage} />
            <Route path="/logoff" exact component={LogoffPage} />
            <Route path="/passwordForgotten" exact component={PasswordForgotten} />
            <Route path="/passwordReset/:token" exact component={PasswordReset} />

            {/* NoMatch Pattern*/}
            <Route path="*" component={HomePage} />
          </Switch>
        </div>
      </Spin>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    authenticationState: state.authenticationState,
    commonState: state.commonState
  };
}

function mapDispatchToProps(dispatch) {
  return {
    authentication: bindActionCreators(authenticationActions, dispatch)
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(App);
